export function selectedTagsFromSearch(search: string): string[] {
  return [...new Set(new URLSearchParams(search).getAll("tag"))];
}

export function toggleTagInSearch(search: string, slug: string): string {
  const params = new URLSearchParams(search);
  const tags = new Set(params.getAll("tag"));
  if (tags.has(slug)) tags.delete(slug); else tags.add(slug);
  params.delete("tag");
  tags.forEach((tag) => params.append("tag", tag));
  return params.toString();
}

export function clearTagsInSearch(search: string): string {
  const params = new URLSearchParams(search);
  params.delete("tag");
  return params.toString();
}

export function singleTagHref(slug: string): string {
  const params = new URLSearchParams();
  params.set("tag", slug);
  return `/?${params.toString()}`;
}
